import styled from '@emotion/styled';
import { nafColor } from '@nafcore/theme';
import { borderRadius, breakpoints, spacing } from '@naf/theme';

export const Modal = styled.div<{ $isSearchActive: boolean }>`
  position: fixed;
  top: ${spacing.space32};
  left: 50%;
  z-index: 100;
  display: flex;
  flex-direction: column;
  width: 680px;
  height: ${({ $isSearchActive }) => ($isSearchActive ? `calc(100vh - ${spacing.space64})` : 'auto')};
  min-height: ${({ $isSearchActive }) => ($isSearchActive ? '0' : '300px')};
  max-height: ${({ $isSearchActive }) =>
    $isSearchActive ? `calc(100vh - ${spacing.space64})` : `calc(100vh - ${spacing.space120})`};
  overflow: hidden;
  transform: translateX(-50%);
  border-radius: ${borderRadius.M};
  background-color: ${nafColor.signature.white};
  box-shadow: 0 16px 40px rgb(6 46 42 / 20%);

  @media (max-width: ${breakpoints.m}) {
    top: ${spacing.space80};
    width: calc(100vw - ${spacing.space24});
    height: ${({ $isSearchActive }) => ($isSearchActive ? `calc(100vh - ${spacing.space120})` : 'auto')};
    min-height: 0;
    max-height: calc(100vh - ${spacing.space80});
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${spacing.space24} 30px 0;

  h2 {
    margin: 0;
  }
`;

export const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${spacing.space48};
  height: ${spacing.space48};
  padding: 0;
  border: none;
  background: transparent;
  color: ${nafColor.signature.black};
  cursor: pointer;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  padding: ${spacing.space24} 30px;

  @media (max-width: ${breakpoints.m}) {
    padding: ${spacing.space24} ${spacing.space16};
  }

  h2,
  h3,
  p {
    color: ${nafColor.signature.black} !important;
  }
`;

export const SearchFieldWrapper = styled.div`
  width: 100%;
`;

export const Divider = styled.hr`
  border: 0;
  width: 100%;
  height: 1px;
  margin: ${spacing.space24} 0 0;
  background-color: ${nafColor.neutral.neutral2};
`;

export const PopularSearches = styled.div``;

export const ChipsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing.space8};
  margin-top: ${spacing.space16};
`;

export const ResultsWrapper = styled.div`
  flex: 1;
  min-height: 0;
  margin-top: ${spacing.space24};
  overflow-y: auto;
`;
